import type { ReportsResponse } from './types'
import type { PartnerReportIndexSuccess } from '~/services/api/generated'

export function normalizeReportsPayload(response: PartnerReportIndexSuccess): ReportsResponse {
  if (response.data === null) {
    return { data: {} }
  }

  return { data: response.data }
}
